export default function (interceptors) {
  interceptors.request.use(config => config, error => error.response);
}

/*
  TODO - improve handle status:
  if (error.response.status === 401) {
      console.log('unauthorized, logging out ...');
      auth.logout();
      router.replace('/auth/login');
  }
 */



// WEBPACK FOOTER //
// ./src/services/interceptors/request-interceptor.js